import { Component, ChangeDetectionStrategy, HostListener, ChangeDetectorRef, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { IdleService } from './admin/services/idle.service';
import { ShareDataService } from './admin/services/share-data.service';
import { Settings, AppSettings } from './app.settings';
import { admin_service } from './admin/services/admin.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})


export class AppComponent implements OnInit {
  loading: boolean = false;
  timerDuration: any = 30;//seconds
  formattedTime: any = '';
  timerInterval: any;
  sessionAlertDuration: any = 150;//seconds
  sessionTimeInterval: any;
  sessionAlertFormattedTime: any;
  isUserIdle: boolean = false;
  refereshTokenTime:number = 10 * 60 * 1000; //every 10 minutes
  refereshTokenInterval:any;
  refreshTimer = 1;
  mainIntervalId:any;

  public settings: Settings;
  constructor(public appSettings: AppSettings, public router: Router,
    private shareDataService: ShareDataService, private cd: ChangeDetectorRef, private idleService: IdleService
    , private admin_service: admin_service,private _snackBar: MatSnackBar) {
    this.settings = this.appSettings.settings;
  }
  a: any = null;

  ngOnInit(): void {
    this.isUserIdle = false;
    localStorage.setItem('idle','false');
    this.a = localStorage.getItem("role")
    document.body.style.zoom = "100%"

    this.idleService.isAlertTrigger.subscribe(res => {
      
      if (res == true) {
        this.isUserIdle = true;
        localStorage.setItem('idle','true');
        this.openIdleAlert();
      }
    });

    this.idleService.isSessionAlertStart.subscribe(res => {
      
      if(res == true) {
        this.startSessionAlertTimer();
      }
    })

    this.idleService.isSessionAlertIntervalTrigger.subscribe(res => {
      if(res == true) {
        
        // this.refereshTokenInterval = setInterval(this.refreshToken,this.refereshTokenTime);
        this.refereshTokenInterval = setInterval(() => {
         
          // this.timerDuration--;
          // const minutes = Math.floor(this.timerDuration / 60);
          // const seconds = this.timerDuration % 60;
          // this.cd.detectChanges();
          // this.formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    
          // if (this.timerDuration <= 0) { //auto logout
          //   this.isUserIdle = false;
          //   localStorage.setItem('idle','false');
          //   this.cd.detectChanges();
          
          //   this.logout();
          // }

          this.refreshTimer++;
         
          if (this.refreshTimer %  1080 == 0) {
            if (this.isUserIdle == false) {
              let token = localStorage.getItem('loginToken');
              this.admin_service.refreshToken({loginToken:token}).subscribe(res => {
                  if (res.code == "200") {
                   
                    localStorage.setItem('loginToken',res.loginToken);
                  } else {
                    this._snackBar.open(res.message, "", { duration: 3000 })
                    this.logout();
                  }
              })
            }
          }
        }, 1000);
       
      }

      if(res == false) {
        
        clearInterval(this.refereshTokenInterval);
        
      }

    })

    this.idleService.clearIntercepterAlert.subscribe(res => {
      
      if(res == true) {
        this.isUserIdle = false;
        localStorage.setItem('idle','false');
        this.refreshTimer = 1;
        this.idleService.clearTimer();
        
        clearInterval(this.timerInterval);
        clearInterval(this.sessionTimeInterval);
        
        clearInterval(this.refereshTokenInterval);
        
      }
    })

    this.idleService.sendMainIntervalId.subscribe(res => {
      
      this.mainIntervalId = res;
    })
    
  }




  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    })
  }

  openIdleAlert() {
    $("#exampleModal").modal("show");
    this.timerDuration = 30;
    this.startIdleAlertTimer();
  }

  closeIdleAlert() {
    $("#exampleModal").modal("hide");
    clearInterval(this.timerInterval);
    this.timerDuration = 30;
    this.isUserIdle = false;
    localStorage.setItem('idle','false');
    this.idleService.timerInitialised = false;
    this.idleService.timerTriggered = false;
    // this.idleService.initListener();
    this.idleService.isUserIdle=false;
    this.idleService.resetTimer();
  }

  logout() {
    $("#exampleModal").modal("hide");
    
    clearInterval(this.timerInterval);
    
    clearInterval(this.sessionTimeInterval);
    this.idleService.isUserIdle=true;
    this.idleService.clearTimer();
    this.idleService.timerInitialised = true;
    this.idleService.timerTriggered = true;
    this.refreshTimer = 1;
    // this.timerDuration = 30;
    this.applicationLogout();
   
  }

  startIdleAlertTimer() {
    this.timerInterval = setInterval(() => {
      
      this.timerDuration--;
      const minutes = Math.floor(this.timerDuration / 60);
      const seconds = this.timerDuration % 60;
      this.cd.detectChanges();
      this.formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      if (this.timerDuration <= 0) { //auto logout
        this.isUserIdle = false;
        localStorage.setItem('idle','false');
        this.cd.detectChanges();
       
        this.logout();
      }
    }, 1000);
  }

  extendSession() {
    $("#sessionAlertModal").modal("hide");
    clearInterval(this.sessionTimeInterval);
    this.sessionAlertDuration = 150;
    this.startSessionAlertTimer();


  }

  applicationLogout() {
    
    clearInterval(this.refereshTokenInterval);
   
    this.admin_service.login_out({ username: localStorage.getItem("name") }).subscribe(res => {
      localStorage.clear();
      this.router.navigateByUrl("/");
    }, err => {
      localStorage.clear();
      this.router.navigateByUrl("/");
    })

  }

  openSessionAlert() {
    $("#sessionAlertModal").modal("show");
    this.startSessionAlertTimer();
  }

  closeSessionAlert() {
    $("#sessionAlertModal").modal("hide");
    clearInterval(this.timerInterval);
    this.shareDataService.isAlertTrigger.next(false);
  }

  startSessionAlertTimer() {
    this.sessionAlertDuration = 150;
    this.sessionTimeInterval = setInterval(() => {
      
      this.sessionAlertDuration--;
      const minutes = Math.floor(this.sessionAlertDuration / 60);
      const seconds = this.sessionAlertDuration % 60;
      this.cd.detectChanges();
      this.sessionAlertFormattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      if (this.sessionAlertDuration == 70) {
        this.cd.detectChanges();
        $("#sessionAlertModal").modal("show");
      }

      if (this.sessionAlertDuration <= 0) { // auto logout
        // $("#sessionAlertModal").modal("hide");
        // clearInterval(this.timerInterval);
        // clearInterval(this.sessionTimeInterval);
        // this.idleService.clearTimer();
        // this.sessionAlertFormattedTime = '';
        // this.sessionAlertDuration = 150;
        // this.Logout();
        this.sessionAlertLogout();
      }
    }, 1000);
  }

  sessionAlertLogout() {
    $("#sessionAlertModal").modal("hide");
    clearInterval(this.timerInterval);
    clearInterval(this.sessionTimeInterval);
    this.idleService.clearTimer();
    this.timerDuration = 30; 
    this.sessionAlertDuration = 150;
    this.applicationLogout();
  }

  refreshToken() {
  
    let flag = localStorage.getItem('idle');
    
    if (flag == 'false') {
      let token = localStorage.getItem('loginToken');
      this.admin_service.refreshToken({loginToken:token}).subscribe(res => {
          if (res.code == "200") {
            
            localStorage.setItem('loginToken',res.loginToken);
          } else {
            this._snackBar.open(res.message, "", { duration: 3000 })
            this.applicationLogout();
          }
      })
    }
  }



}
